import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { AppState } from 'src/app/angular-wallet-base/store/appState';

@Component({
  selector: 'app-payment-confirmation-modal',
  templateUrl: './payment-confirmation-modal.html',
  styleUrls: ['./payment-confirmation-modal.scss'],
})
export class SimplexPaymentConfirmationModalComponent implements OnInit {
  public isDesktopMode;
  public payment_id: string;

  constructor(private modalController: ModalController, public appMode: AppModeService, protected store: Store<AppState>) {
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
  }

  ngOnInit() {}

  closeModal(allowPayment?: string) {
    this.modalController.dismiss(allowPayment);
  }
}
